import { api } from "../../services/api"
import { GetRateCardApi, listAllUserApi }  from "../../services/apiVariables" 
import { GetMonthYear, GetCurrentDate } from '@src/function.js'

// ----------------------Product----------------------------
export function superAdminRateCard () {
   return (dispatch) => {  
    dispatch({ type: 'RateCard_LOADING' }) 
    api(GetRateCardApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'RateCard_SUCCESS', data }),
           error => dispatch({ type:'RateCard_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}
